import { type FC } from 'react';
import dynamic from 'next/dynamic';
import { useTranslations } from 'next-intl';

import { EditInn } from '@features/merchant';

import { Box, Flex, Text } from '@shared/ui-kit';

const DateLabel = dynamic(
  () => import('@shared/ui-kit').then((m) => m.DateLabel),
  {
    ssr: false,
  },
);

interface Props {
  id: string;
  tin: string;
  marketplacesCount: number;
  last_imported_at: string;
}

const CardBody: FC<Props> = (props) => {
  const { id, tin, marketplacesCount, last_imported_at } = props;
  const t = useTranslations();

  return (
    <>
      <Flex
        direction="column"
        rowGap="2.5"
      >
        <EditInn
          merchantId={id}
          merchantTin={tin}
        />
        {last_imported_at && (
          <Box className="fg-of-link">
            <DateLabel
              data-qa-selector="merchant_last_imported_at"
              tooltip={t('Tooltips.lastImportDate')}
              date={last_imported_at}
            />
          </Box>
        )}
      </Flex>
      <Box className="fg-of-link">
        {marketplacesCount ? (
          <Text
            fontSize="sm"
            whiteSpace="nowrap"
          >
            {}
            <b>{marketplacesCount}</b>
            &nbsp;
            {t('Marketplace.Count.total', { count: marketplacesCount })}
          </Text>
        ) : (
          <Text
            fontSize="sm"
            whiteSpace="nowrap"
          >
            {t('Marketplace.Count.none')}
          </Text>
        )}
      </Box>
    </>
  );
};

export default CardBody;
